import { Box, Typography } from '@material-ui/core'
import config from '../../config'
export const url = config.PUBLIC_URL + '/img/logo_blanc.png'
export const url2 = config.PUBLIC_URL + '/img/logo.png'

const Footer = () => (
  <div
    className="footer"
    style={{
      position: 'fixed',
      bottom: '5px',
      left: '20px',
    }}
  >
    <Box
      display="flex"
      sx={{
        alignItems: 'center',
      }}
    >
      <Box mr="0.5em" ml="0.5em">
        <img
          src={url2}
          width="100"
          style={{ marginTop: '0px', marginLeft: '25px' }}
        />
      </Box>
      <Box mr="0.5em" ml="0.5em">
        <Typography
          variant="caption"
          style={{
            fontSize: '9px',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            lineHeight: '1.2',
          }}
        >
          <span>
            Manda (Ex-Hello Syndic) S.A.S. – 30 Terrasse Bellini - 92800 Puteaux
          </span>
          <span>
            Société Immatriculée au RCS de Paris : 828 499 897 et au capital de
            35216€
          </span>
          <span>N° de TVA intracommunautaire : FR 27 828499897</span>
          <span>
            Carte professionnelle n°CPI 7501 2017 000 019 252, garantie
            financière auprès de Galian
          </span>
        </Typography>
      </Box>
      <Box flex={1} mr="0.5em" ml="0.5em">
        &nbsp;
      </Box>
    </Box>
  </div>
)
export default Footer
